<template>
  <div class="bread-crumb-wrapper" v-show="!isMobile">
    <router-link to="/">
      <div class="d-flex bread-crumb">
        <image-component
          path=""
          :isJpg="false"
          name="ic_home"
        ></image-component>
        <span class="route">홈</span>
      </div>
    </router-link>
    /
    <router-link :to="{name: route}" @click.native="goRoutePage"
      ><span class="route">{{ routeList[route].name }}</span>
    </router-link>
    /
    <span class="route current-page">
      {{ routeList[route].sub[currentRoute].name }}
    </span>
  </div>
</template>

<script>
import ImageComponent from "./imageComponent.vue";
export default {
  components: {ImageComponent},
  props: {
    path: Object,
  },

  data() {
    return {
      routeList: {
        happytable: {
          name: "해피테이블",
          sub: {
            happytable: {name: "브랜드 이야기"},
            award: {name: "인증 및 수상"},
          },
        },
        product: {
          name: "제품 소개",
          sub: {
            0: {name: "43인치"},
            1: {name: "32인치"},
            2: {name: "해피태블릿"},
          },
        },
        productinfo: {
          name: "제품 소개",
          sub: {
            productinfo: {name: "43인치"},
            "32inch": {name: "32인치"},
          },
        },
        game: {
          name: "게임 소개",
          sub: {
            0: {name: "전체"},
            1: {name: "협동"},
            2: {name: "경쟁"},
            3: {name: "힐링"},
            4: {name: "학습"},
          },
        },
        cognition: {
          name: "게임 소개",
          sub: {
            cognition: {name: "기능성 게임"},
            multigame: {name: "멀티 게임"},
            cognitionDetail: {name: "인지 평가 게임"},
            story: {name: "스토리 웹툰"},
          },
        },
        news: {
          name: "소식",
          sub: {
            news: {name: "공지사항"},
            reference: {name: "설치 사례"},
            faq: {name: "FAQ"},
          },
        },
      },
      isMobile: false,
    };
  },
  computed: {
    route() {
      return this.path.path.split("/")[1];
    },
    currentRoute() {
      if (
        this.path.query.index === undefined ||
        this.path.name === "cognition"
      ) {
        return this.path.name;
      }
      return this.path.query.index;
    },
  },
  methods: {
    goRoutePage() {
      if (this.route === "product" || this.route === "game") {
        this.$router.push({
          name: this.route,
          query: {index: 0},
        });
        return;
      } else {
        if (this.$router.currentRoute.name !== this.route) {
          this.$router.push({
            name: this.route,
          });
        }
      }
    },
    checkBrowserWidth() {
      // this.isMobile = window.innerWidth <= 1200;
    },
  },
  created() {
    this.checkBrowserWidth();
    window.addEventListener("resize", this.checkBrowserWidth);
  },
};
</script>

<style scoped>
.bread-crumb-wrapper {
  margin: 1rem 0;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.route.current-page {
  color: #f83f1b;
}
a {
  text-decoration: none;
}
.route {
  font-size: 14px;
  color: black;
  padding: 0 0.4rem;
}
a >>> .imgWrap {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
